"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAX_CREDITS_EXCLUDED_BY_PROVINCE = exports.TAX_CREDITS = exports.INCOME_SOURCES_EXCLUDED_BY_PROVINCE = exports.INCOME_SOURCES = exports.QUESTION_CATEGORIES_SPECIFIC_TO_PROVINCE = exports.QUESTION_CATEGORIES = exports.PREFERRED_CONTACT_METHODS = exports.INVESTMENT_PLATFORM_INTEREST_LEVELS = void 0;
const person_1 = require("./person");
var INVESTMENT_PLATFORM_INTEREST_LEVELS;
(function (INVESTMENT_PLATFORM_INTEREST_LEVELS) {
    INVESTMENT_PLATFORM_INTEREST_LEVELS["veryInterested"] = "veryInterested";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["interested"] = "interested";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["notReally"] = "notReally";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["notAtAll"] = "notAtAll";
    INVESTMENT_PLATFORM_INTEREST_LEVELS["dontKnow"] = "dontKnow";
})(INVESTMENT_PLATFORM_INTEREST_LEVELS = exports.INVESTMENT_PLATFORM_INTEREST_LEVELS || (exports.INVESTMENT_PLATFORM_INTEREST_LEVELS = {}));
var PREFERRED_CONTACT_METHODS;
(function (PREFERRED_CONTACT_METHODS) {
    PREFERRED_CONTACT_METHODS["email"] = "email";
    PREFERRED_CONTACT_METHODS["phone"] = "phone";
})(PREFERRED_CONTACT_METHODS = exports.PREFERRED_CONTACT_METHODS || (exports.PREFERRED_CONTACT_METHODS = {}));
var QUESTION_CATEGORIES;
(function (QUESTION_CATEGORIES) {
    QUESTION_CATEGORIES["drugInsurance"] = "drugInsurance";
    QUESTION_CATEGORIES["solidarityTaxCredit"] = "solidarityTaxCredit";
    QUESTION_CATEGORIES["trilliumBenefit"] = "trilliumBenefit";
    QUESTION_CATEGORIES["rentersTaxCredit"] = "rentersTaxCredit";
    QUESTION_CATEGORIES["incomeSources"] = "incomeSources";
    QUESTION_CATEGORIES["rrsp"] = "rrsp";
    QUESTION_CATEGORIES["children"] = "children";
    QUESTION_CATEGORIES["student"] = "student";
    QUESTION_CATEGORIES["taxCredits"] = "taxCredits";
    QUESTION_CATEGORIES["generalQuestions"] = "generalQuestions";
    QUESTION_CATEGORIES["otherInformation"] = "otherInformation";
})(QUESTION_CATEGORIES = exports.QUESTION_CATEGORIES || (exports.QUESTION_CATEGORIES = {}));
exports.QUESTION_CATEGORIES_SPECIFIC_TO_PROVINCE = {
    [person_1.PROVINCES.qc]: [QUESTION_CATEGORIES.drugInsurance, QUESTION_CATEGORIES.solidarityTaxCredit],
    [person_1.PROVINCES.on]: [QUESTION_CATEGORIES.trilliumBenefit],
    [person_1.PROVINCES.bc]: [QUESTION_CATEGORIES.rentersTaxCredit],
};
var INCOME_SOURCES;
(function (INCOME_SOURCES) {
    INCOME_SOURCES["none"] = "none";
    INCOME_SOURCES["employment"] = "employment";
    INCOME_SOURCES["rentalBuilding"] = "rentalBuilding";
    INCOME_SOURCES["rentalBuildingAbroad"] = "rentalBuildingAbroad";
    INCOME_SOURCES["retirement"] = "retirement";
    INCOME_SOURCES["retirementPsv"] = "retirementPsv";
    INCOME_SOURCES["retirementRrq"] = "retirementRrq";
    INCOME_SOURCES["cpp"] = "cpp";
    INCOME_SOURCES["retirementPension"] = "retirementPension";
    INCOME_SOURCES["retirementRrif"] = "retirementRrif";
    INCOME_SOURCES["investment"] = "investment";
    INCOME_SOURCES["stocksSecuritiesCryptocurrencies"] = "stocksSecuritiesCryptocurrencies";
    INCOME_SOURCES["socialAssistance"] = "socialAssistance";
    INCOME_SOURCES["cnesst"] = "cnesst";
    INCOME_SOURCES["ivac"] = "ivac";
    INCOME_SOURCES["employmentInsurance"] = "employmentInsurance";
    INCOME_SOURCES["qpip"] = "qpip";
    INCOME_SOURCES["taxableSalaryInsurance"] = "taxableSalaryInsurance";
    INCOME_SOURCES["saaq"] = "saaq";
    INCOME_SOURCES["trustIncome"] = "trustIncome";
    INCOME_SOURCES["cerb"] = "cerb";
    INCOME_SOURCES["foreignIncome"] = "foreignIncome";
    INCOME_SOURCES["other"] = "other";
})(INCOME_SOURCES = exports.INCOME_SOURCES || (exports.INCOME_SOURCES = {}));
const QUEBEC_ONLY_INCOME_SOURCES = [
    INCOME_SOURCES.retirementRrq,
    INCOME_SOURCES.qpip,
    INCOME_SOURCES.saaq,
];
exports.INCOME_SOURCES_EXCLUDED_BY_PROVINCE = {
    [person_1.PROVINCES.ab]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.bc]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.mb]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.nb]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.nl]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.ns]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.nt]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.nu]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.on]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.pe]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.qc]: [INCOME_SOURCES.cpp],
    [person_1.PROVINCES.sk]: [...QUEBEC_ONLY_INCOME_SOURCES],
    [person_1.PROVINCES.yt]: [...QUEBEC_ONLY_INCOME_SOURCES],
};
var TAX_CREDITS;
(function (TAX_CREDITS) {
    TAX_CREDITS["no"] = "no";
    TAX_CREDITS["disabledPerson"] = "disabledPerson";
    TAX_CREDITS["homeSupport"] = "homeSupport";
    TAX_CREDITS["familyCaregivers"] = "familyCaregivers";
    TAX_CREDITS["remoteAreas"] = "remoteAreas";
    TAX_CREDITS["movingExpenses"] = "movingExpenses";
    TAX_CREDITS["renoVert"] = "renoVert";
    TAX_CREDITS["homeAccessibility"] = "homeAccessibility";
    TAX_CREDITS["volunteer"] = "volunteer";
    TAX_CREDITS["teacherSchoolSupply"] = "teacherSchoolSupply";
    TAX_CREDITS["employmentExpenses"] = "employmentExpenses";
    TAX_CREDITS["recentGraduatesRemote"] = "recentGraduatesRemote";
})(TAX_CREDITS = exports.TAX_CREDITS || (exports.TAX_CREDITS = {}));
const QUEBEC_ONLY_TAX_CREDITS = [TAX_CREDITS.homeSupport, TAX_CREDITS.recentGraduatesRemote];
exports.TAX_CREDITS_EXCLUDED_BY_PROVINCE = {
    [person_1.PROVINCES.ab]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.bc]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.mb]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.nb]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.nl]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.ns]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.nt]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.nu]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.on]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.pe]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.qc]: [],
    [person_1.PROVINCES.sk]: [...QUEBEC_ONLY_TAX_CREDITS],
    [person_1.PROVINCES.yt]: [...QUEBEC_ONLY_TAX_CREDITS],
};
//# sourceMappingURL=answers.js.map